export const GeoJson = {
    list: function() {
        // get the page length when first load
        var initWindowHeight = jQuery(window).height();
        var initItemsPerPage = getPageLength(initWindowHeight);

        var table = jQuery('table.geo-json').DataTable({
            data: JSON.parse(jQuery('#geo-json-data').html()),
            info: false,
            lengthChange: false,
            language: {
                searchPlaceholder: I18n.t('search')
              },
            pageLength: initItemsPerPage, 
            autoWidth: false,
            columnDefs: [
                {
                    render: function(data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#geo-json-variable-name-template').html().
                                replace(/__id__/g, data.id).
                                replace(/__label__/g, data.label);
                        }
                        return data.label;
                    },
                    targets: [0]
                },
                {
                    render: function(data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#geo-json-variable-link-template').html().
                                replace(/__id__/g, data.id).
                                replace(/__label__/g, data.label);
                        }
                        return data.label;
                    },
                    targets: [2]
                },
                {
                    orderable: false,
                    render: function(data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#geo-json-variable-actions-template').html().
                                replace(/__id__/g, data.id);
                        }
                        return '';
                    },
                    targets: [3]
                }
            ]
        });

        table.on('click', 'a.delete-variable', function() {
            var a = jQuery(this);

            if (confirm(a.attr('data-confirm'))) {
                jQuery.post(a.attr('href'), function() {
                    Turbo.visit(window.location.href);
                });
                a.hide();
            }
            return false;
        });
        var resizeId;
        // get the length after user stop resizing for 500ms
        jQuery(window).resize(function(){
            clearTimeout(resizeId);
            resizeId = setTimeout(resizeList, 500);
        })
        function resizeList(){
            var windowHeight = jQuery(window).height();
            var itemsPerPage = getPageLength(windowHeight);
            if (itemsPerPage!=table.page.len()){
                table.page.len(parseInt(itemsPerPage)).draw();
            }
        }
        function getPageLength(height) {
            switch(true){
                case height>1100:
                    return 20;
                case height>800:
                    return 15;
                case height>600:
                    return 10;
                default:
                    return 5;
            }
        }
    },
    _form: function() {
        jQuery('.select2').select2();
        const changeOptionsField = (name, optName, newGridId) => {
            const allOptions = JSON.parse(jQuery('#variable_datagrid_id').attr(`data-${optName}-options`));
            if (allOptions){
                const field = jQuery(`#variable_${name}`);
                field.empty();
                field.append($("<option></option>").attr("value", '').text(I18n.t('react_select_placeholder')));
                if (allOptions[newGridId].length > 0){
                    allOptions[newGridId].forEach((e) => {
                        field.append($("<option></option>").attr("value", e[0]).text(e[1]));
                      });
                }
            }
        }
        jQuery('#variable_datagrid_id').on('change', function(e){
            const newGridId = parseInt(e.target.value);
            changeOptionsField('coordinate', 'coordinate', newGridId);
            changeOptionsField('preset', 'preset', newGridId);
            changeOptionsField('lat', 'decimal', newGridId);
            changeOptionsField('lng', 'decimal', newGridId);
            changeOptionsField('selected_columns', 'all', newGridId);
        })
        jQuery('#variable_coordinate_type').on('change', function(e){
            const newOpt = e.target.value;
            const newGridId = jQuery('#variable_datagrid_id').val();
            if (newOpt == 'decimal'){
                jQuery('.coordinate-type.coordinate').addClass('d-none');
                changeOptionsField('lat', 'decimal', newGridId);
                changeOptionsField('lng', 'decimal', newGridId);
                jQuery('.coordinate-type.decimal').removeClass('d-none');
            } else if (newOpt == 'coordinate'){
                jQuery('.coordinate-type.decimal').addClass('d-none');
                changeOptionsField('coordinate', 'coordinate', newGridId);
                jQuery('.coordinate-type.coordinate').removeClass('d-none');
            }
        })
    }
}
